<template>
  <div class="tariffs-widget">
    <div
        class="tariffs-widget__card"
        :class="{ 'tariffs-widget__card--empty': !hasMyService }"
        @click="openMyTariffs"
    >
      <div class="tariffs-widget__header">
        <div class="tariffs-widget__service-type">{{ serviceTypeLabel }}</div>
        <div v-if="statusLabel" class="tariffs-widget__status" :class="statusClass">
          {{ statusLabel }}
        </div>
      </div>

      <div class="tariffs-widget__title">{{ serviceTitle }}</div>
      <div class="tariffs-widget__subtitle">{{ serviceCountText }}</div>

      <div class="tariffs-widget__services" v-if="serviceSummaries.length">
        <button
            v-for="(service, index) in serviceSummaries"
            :key="service.key + '-' + index"
            type="button"
            class="tariffs-widget__service"
            :style="{
              color: service.color,
              backgroundColor: service.secondaryColor
            }"
            @click.stop="openServiceDetails(service)"
        >
          <svg :viewBox="service.iconViewBox" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
                v-for="(path, pathIndex) in service.iconPaths"
                :key="pathIndex"
                :d="path"
                fill="currentColor"
            />
          </svg>
          <span class="tariffs-widget__service-label">{{ service.label }}</span>
        </button>
      </div>

      <div v-if="hasPaymentInfo" class="tariffs-widget__payment" :style="paymentStyle">
        <span class="tariffs-widget__payment-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.819,13.363C3.921,13.363 3.091,13.678 2.432,14.203C1.554,14.9 1,15.979 1,17.181C1,19.291 2.709,21 4.819,21C5.783,21 6.661,20.637 7.339,20.045C8.131,19.348 8.637,18.327 8.637,17.181C8.637,15.072 6.928,13.363 4.819,13.363ZM5.773,17.42C5.773,17.668 5.64,17.907 5.43,18.031L4.236,18.747C4.122,18.823 3.988,18.852 3.864,18.852C3.625,18.852 3.387,18.728 3.253,18.508C3.053,18.165 3.158,17.726 3.501,17.525L4.351,17.019V15.988C4.341,15.597 4.666,15.272 5.057,15.272C5.449,15.272 5.773,15.597 5.773,15.988V17.42Z" fill="currentColor" />
            <path d="M14.222,2.814V6.442H12.79V2.814C12.79,2.556 12.561,2.432 12.408,2.432C12.36,2.432 12.313,2.442 12.265,2.461L4.695,5.315C4.189,5.506 3.864,5.983 3.864,6.527V7.167C2.995,7.816 2.432,8.857 2.432,10.031V6.527C2.432,5.391 3.129,4.379 4.189,3.979L11.769,1.115C11.979,1.038 12.198,1 12.408,1C13.363,1 14.222,1.773 14.222,2.814Z" fill="currentColor" />
            <path d="M20.57,12.885V13.84C20.57,14.098 20.37,14.308 20.103,14.317H18.709C18.203,14.317 17.745,13.945 17.706,13.449C17.678,13.153 17.792,12.876 17.983,12.685C18.155,12.504 18.394,12.408 18.652,12.408H20.093C20.37,12.418 20.57,12.628 20.57,12.885Z" fill="currentColor" />
            <path d="M18.642,11.406H19.616C20.141,11.406 20.57,10.976 20.57,10.451V10.031C20.57,8.055 18.957,6.442 16.981,6.442H6.021C5.21,6.442 4.465,6.709 3.864,7.167C2.995,7.816 2.432,8.857 2.432,10.031V11.73C2.432,12.093 2.814,12.322 3.158,12.208C3.692,12.026 4.255,11.931 4.819,11.931C7.711,11.931 10.069,14.289 10.069,17.181C10.069,17.869 9.888,18.623 9.601,19.291C9.449,19.635 9.687,20.045 10.06,20.045H16.981C18.957,20.045 20.57,18.432 20.57,16.456V16.274C20.57,15.75 20.141,15.32 19.616,15.32H18.785C17.869,15.32 16.99,14.757 16.752,13.869C16.561,13.143 16.79,12.437 17.267,11.979C17.621,11.616 18.107,11.406 18.642,11.406ZM13.41,11.215H8.637C8.246,11.215 7.921,10.89 7.921,10.499C7.921,10.108 8.246,9.783 8.637,9.783H13.41C13.802,9.783 14.127,10.108 14.127,10.499C14.127,10.89 13.802,11.215 13.41,11.215Z" fill="currentColor" />
          </svg>
        </span>
        <span class="tariffs-widget__payment-text">
          Списание <span class="tariffs-widget__payment-amount">{{ myService.chargeAmount }}</span> {{ myService.chargeDate }}
        </span>
      </div>
    </div>

    <div class="tariffs-widget__all">
      <div class="tariffs-widget__all-header">
        <div class="tariffs-widget__all-title">Все услуги</div>
        <div class="tariffs-widget__scroll-controls">
          <button
              type="button"
              class="tariffs-widget__scroll-button"
              :class="{ 'tariffs-widget__scroll-button--disabled': !scrollState.canScrollLeft }"
              :disabled="!scrollState.canScrollLeft"
              @click="scrollServices('left')"
              aria-label="Прокрутить влево"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                  d="M14.53 5.53a.75.75 0 0 1 0 1.06L10.12 11l4.41 4.41a.75.75 0 0 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0Z"
                  fill="currentColor"
              />
            </svg>
          </button>
          <button
              type="button"
              class="tariffs-widget__scroll-button"
              :class="{ 'tariffs-widget__scroll-button--disabled': !scrollState.canScrollRight }"
              :disabled="!scrollState.canScrollRight"
              @click="scrollServices('right')"
              aria-label="Прокрутить вправо"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                  d="M9.47 18.47a.75.75 0 0 1 0-1.06L13.88 13 9.47 8.59a.75.75 0 0 1 1.06-1.06l5 5a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0Z"
                  fill="currentColor"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="tariffs-widget__all-scroll">
        <div
            ref="allServices"
            class="tariffs-widget__all-list"
            @scroll="handleServicesScroll"
        >
          <item-tariff-main
              v-for="service in serviceCards"
              :key="service.key"
              :service="service"
              @select="handleServiceSelect"
          />
        </div>
      </div>
    </div>

    <div v-if="quickActions.length" class="tariffs-widget__shortcuts">
      <button
          v-for="action in quickActions"
          :key="action.key"
          type="button"
          :class="['tariffs-widget__shortcut', { 'tariffs-widget__shortcut--disabled': action.disabled }]"
          :disabled="action.disabled"
          @click="handleShortcut(action)"
      >
        <span
            class="tariffs-widget__shortcut-icon"
            :style="{
              color: action.color,
              backgroundColor: action.background
            }"
            aria-hidden="true"
        >
          <svg :viewBox="action.iconViewBox" xmlns="http://www.w3.org/2000/svg">
            <path
                v-for="(path, index) in action.iconPaths"
                :key="index"
                v-bind="typeof path === 'string' ? { d: path, fill: 'currentColor' } : path"
            />
          </svg>
        </span>
        <span class="tariffs-widget__shortcut-label">{{ action.label }}</span>
      </button>
    </div>

    <transition name="fade">
      <div v-if="dialog.visible" class="tariffs-widget__dialog-backdrop" @click="closeDialog">
        <div class="tariffs-widget__dialog" @click.stop>
          <div class="tariffs-widget__dialog-header">
            <div class="tariffs-widget__dialog-title">{{ dialog.title }}</div>
            <button type="button" class="tariffs-widget__dialog-close" @click="closeDialog">×</button>
          </div>
          <ul v-if="dialog.details.length" class="tariffs-widget__dialog-list">
            <li v-for="(detail, index) in dialog.details" :key="index">{{ detail }}</li>
          </ul>
          <div v-else class="tariffs-widget__dialog-empty">Нет подробной информации по услуге.</div>
          <div v-if="canToggleBlock()" class="tariffs-widget__dialog-actions">
            <button
                type="button"
                class="tariffs-widget__dialog-button"
                :class="isServiceBlocked() ? 'tariffs-widget__dialog-button--unblock' : 'tariffs-widget__dialog-button--block'"
                :disabled="isBlockLoading"
                @click="toggleBlockService"
            >
              {{ isServiceBlocked() ? 'Разблокировать' : 'Заблокировать' }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ItemTariffMain from './item-tariff-main';
import axios from "axios";

const SERVICE_META = {
  Internet: {
    key: 'Internet',
    label: 'Интернет',
    color: '#34C234',
    secondaryColor: '#E7FFE7',
    iconViewBox: '0 0 24 24',
    iconPaths: [
      'M7.65,20.91C7.62,20.91 7.58,20.93 7.55,20.93C5.61,19.97 4.03,18.38 3.06,16.44C3.06,16.41 3.08,16.37 3.08,16.34C4.3,16.7 5.56,16.97 6.81,17.18C7.03,18.44 7.29,19.69 7.65,20.91Z',
      'M20.94,16.45C19.95,18.44 18.3,20.05 16.29,21.02C16.67,19.75 16.99,18.47 17.2,17.18C18.46,16.97 19.7,16.7 20.92,16.34C20.91,16.38 20.94,16.42 20.94,16.45Z',
      'M21.02,7.71C19.76,7.33 18.49,7.02 17.2,6.8C16.99,5.51 16.68,4.23 16.29,2.98C18.36,3.97 20.03,5.64 21.02,7.71Z',
      'M7.65,3.09C7.29,4.31 7.03,5.55 6.82,6.81C5.53,7.01 4.25,7.33 2.98,7.71C3.95,5.7 5.56,4.05 7.55,3.06C7.58,3.06 7.62,3.09 7.65,3.09Z',
      'M15.49,6.59C13.17,6.33 10.83,6.33 8.51,6.59C8.76,5.22 9.08,3.85 9.53,2.53C9.55,2.45 9.54,2.39 9.55,2.31C10.34,2.12 11.15,2 12,2C12.84,2 13.66,2.12 14.44,2.31C14.45,2.39 14.45,2.45 14.47,2.53C14.92,3.86 15.24,5.22 15.49,6.59Z',
      'M6.59,15.49C5.21,15.24 3.85,14.92 2.53,14.47C2.45,14.45 2.39,14.46 2.31,14.45C2.12,13.66 2,12.85 2,12C2,11.16 2.12,10.34 2.31,9.56C2.39,9.55 2.45,9.55 2.53,9.53C3.86,9.09 5.21,8.76 6.59,8.51C6.34,10.83 6.34,13.17 6.59,15.49Z',
      'M22,12C22,12.85 21.88,13.66 21.69,14.45C21.61,14.46 21.55,14.45 21.47,14.47C20.14,14.91 18.78,15.24 17.41,15.49C17.67,13.17 17.67,10.83 17.41,8.51C18.78,8.76 20.15,9.08 21.47,9.53C21.55,9.55 21.61,9.56 21.69,9.56C21.88,10.35 22,11.16 22,12Z',
      'M15.49,17.41C15.24,18.79 14.92,20.15 14.47,21.47C14.45,21.55 14.45,21.61 14.44,21.69C13.66,21.88 12.84,22 12,22C11.15,22 10.34,21.88 9.55,21.69C9.54,21.61 9.55,21.55 9.53,21.47C9.09,20.14 8.76,18.79 8.51,17.41C9.67,17.54 10.83,17.63 12,17.63C13.17,17.63 14.34,17.54 15.49,17.41Z',
      'M15.763,15.763C13.262,16.079 10.738,16.079 8.237,15.763C7.921,13.262 7.921,10.738 8.237,8.237C10.738,7.921 13.262,7.921 15.763,8.237C16.079,10.738 16.079,13.262 15.763,15.763Z'
    ],
    route: '/tariffs?type=internet',
    audience: 'phys'
  },
  Tv: {
    key: 'Tv',
    label: 'Телевидение',
    color: '#FF407F',
    secondaryColor: '#FFEAF1',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M19.64,2.667H12.36V8.48H19.64V2.667Z',
      'M21.64,2.667V8.48H29.16C28.48,4.813 25.773,2.68 21.64,2.667Z',
      'M2.667,10.48V21.587C2.667,26.44 5.56,29.333 10.414,29.333H21.587C26.44,29.333 29.334,26.44 29.334,21.587V10.48H2.667ZM19.254,21.573L16.48,23.173C15.894,23.507 15.32,23.68 14.787,23.68C14.387,23.68 14.027,23.587 13.694,23.4C12.92,22.96 12.494,22.053 12.494,20.88V17.68C12.494,16.507 12.92,15.6 13.694,15.16C14.467,14.707 15.454,14.787 16.48,15.387L19.254,16.987C20.28,17.573 20.84,18.4 20.84,19.293C20.84,20.187 20.267,20.973 19.254,21.573Z',
      'M10.36,2.667C6.227,2.68 3.52,4.813 2.84,8.48H10.36V2.667Z'
    ],
    route: '/tariffs?type=tv',
    audience: 'phys'
  },
  Vacation: {
    key: 'Vacation',
    label: 'Отпуск',
    color: '#FFB200',
    secondaryColor: '#FFF9EA',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M24.64,16.333C25.013,16.333 25.333,16.013 25.306,15.64C24.946,10.8 20.92,7 16,7C11.08,7 7.053,10.8 6.693,15.64C6.666,16.013 6.986,16.333 7.36,16.333H24.64Z',
      'M29.333,17.333H29.226C28.493,17.333 27.893,16.733 27.893,16C27.893,15.267 28.493,14.667 29.226,14.667C29.96,14.667 30.613,15.267 30.613,16C30.613,16.733 30.066,17.333 29.333,17.333ZM2.773,17.333H2.666C1.933,17.333 1.333,16.733 1.333,16C1.333,15.267 1.933,14.667 2.666,14.667C3.4,14.667 4.053,15.267 4.053,16C4.053,16.733 3.506,17.333 2.773,17.333ZM25.346,7.987C25,7.987 24.666,7.853 24.4,7.6C23.88,7.08 23.88,6.24 24.4,5.72L24.573,5.547C25.093,5.027 25.933,5.027 26.453,5.547C26.973,6.067 26.973,6.907 26.453,7.427L26.28,7.6C26.026,7.853 25.693,7.987 25.346,7.987ZM6.653,7.987C6.306,7.987 5.973,7.853 5.706,7.6L5.533,7.413C5.013,6.893 5.013,6.054 5.533,5.534C6.053,5.014 6.893,5.014 7.413,5.534L7.586,5.707C8.106,6.227 8.106,7.067 7.586,7.587C7.333,7.853 6.986,7.987 6.653,7.987ZM16,4.054C15.266,4.054 14.666,3.507 14.666,2.773V2.667C14.666,1.934 15.266,1.334 16,1.334C16.733,1.334 17.333,1.934 17.333,2.667C17.333,3.4 16.733,4.054 16,4.054Z',
      'M26.666,21H5.333C4.786,21 4.333,20.547 4.333,20C4.333,19.453 4.786,19 5.333,19H26.666C27.213,19 27.666,19.453 27.666,20C27.666,20.547 27.213,21 26.666,21Z',
      'M24,25H8C7.453,25 7,24.547 7,24C7,23.453 7.453,23 8,23H24C24.547,23 25,23.453 25,24C25,24.547 24.547,25 24,25Z',
      'M20,29H12C11.453,29 11,28.547 11,28C11,27.453 11.453,27 12,27H20C20.547,27 21,27.453 21,28C21,28.547 20.547,29 20,29Z'
    ],
    route: '/service?type=vacation',
    statusKey: 'vacationActive',
    audience: 'phys'
  },
  videoSurveillance: {
    key: 'videoSurveillance',
    label: 'Видеонаблюдение',
    color: '#5CC6FF',
    secondaryColor: '#EFF9FF',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M27.96,13.827V18.08C27.96,21.173 25.454,23.68 22.36,23.68H17.614C16.88,23.68 16.28,24.267 16.28,25.013V26.107C16.28,26.84 16.88,27.44 17.614,27.44H20.627C21.147,27.44 21.574,27.853 21.574,28.387C21.574,28.907 21.147,29.333 20.627,29.333H10.04C9.52,29.333 9.094,28.907 9.094,28.387C9.094,27.853 9.52,27.44 10.04,27.44H13.054C13.787,27.44 14.387,26.84 14.387,26.107V25.013C14.387,24.267 13.787,23.68 13.054,23.68H8.254C5.174,23.68 2.667,21.173 2.667,18.08V9.587C2.667,6.507 5.174,4 8.254,4H14C14.734,4 15.334,4.6 15.334,5.333V8.2C15.334,10.773 17.054,12.493 19.614,12.493H26.627C27.36,12.493 27.96,13.093 27.96,13.827Z',
      'M29.32,3.147L27.813,4.2V3.64C27.813,2.373 26.786,1.36 25.533,1.36H19.826C18.453,1.347 17.333,2.467 17.333,3.84V8.213C17.333,9.36 17.906,10.493 19.613,10.493H25.52C26.786,10.493 27.8,9.467 27.8,8.213V7.64L29.306,8.693C30.066,9.213 30.666,8.893 30.666,7.987V3.853C30.666,2.947 30.066,2.64 29.32,3.147Z'
    ],
    route: '/camera',
    statusKey: 'videoActive',
    audience: 'all'
  },
  staticIP: {
    key: 'staticIP',
    label: 'IP-адрес',
    color: '#6281FF',
    secondaryColor: '#F0F3FF',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M27.493,11.6C26.106,5.426 20.72,2.667 16,2.667C16,2.667 16,2.667 15.986,2.667C11.28,2.667 5.906,5.426 4.506,11.587C2.933,18.466 7.146,24.293 10.96,27.973C12.373,29.333 14.186,30.013 16,30.013C17.813,30.013 19.626,29.333 21.026,27.973C24.84,24.293 29.053,18.48 27.493,11.6ZM20.373,12.707L15.04,18.04C14.84,18.24 14.586,18.333 14.333,18.333C14.08,18.333 13.826,18.24 13.626,18.04L11.626,16.04C11.24,15.653 11.24,15.013 11.626,14.627C12.013,14.24 12.653,14.24 13.04,14.627L14.333,15.92L18.96,11.293C19.346,10.906 19.986,10.906 20.373,11.293C20.76,11.68 20.76,12.32 20.373,12.707Z'
    ],
    route: '/service?type=staticIP',
    statusKey: 'staticIpActive',
    audience: 'all'
  },
  smartHome: {
    key: 'smartHome',
    label: 'Умный дом',
    color: '#9162FF',
    secondaryColor: '#F4F0FF',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M27.813,11.413L18.573,4.027C17.146,2.88 14.84,2.88 13.426,4.013L4.186,11.413C3.146,12.24 2.48,13.987 2.706,15.293L4.48,25.907C4.8,27.8 6.613,29.333 8.533,29.333H23.466C25.373,29.333 27.2,27.787 27.52,25.907L29.293,15.293C29.506,13.987 28.84,12.24 27.813,11.413ZM12.506,23.173C11.76,23.173 11.173,22.573 11.173,21.84C11.173,21.107 11.773,20.507 12.506,20.507C13.24,20.507 13.84,21.107 13.84,21.84C13.84,22.573 13.24,23.173 12.506,23.173ZM16.52,22.827C16.506,22.827 16.506,22.827 16.493,22.827C15.946,22.827 15.506,22.387 15.493,21.853C15.453,20.053 14.266,18.867 12.466,18.827C11.92,18.813 11.48,18.36 11.493,17.8C11.506,17.253 11.946,16.827 12.493,16.827C12.506,16.827 12.506,16.827 12.52,16.827C15.386,16.893 17.44,18.933 17.493,21.8C17.506,22.36 17.08,22.827 16.52,22.827ZM20.506,22.827C19.946,22.827 19.506,22.387 19.493,21.84C19.48,20.96 19.333,20.12 19.066,19.333C18.386,17.387 16.933,15.947 14.986,15.253C14.2,14.973 13.36,14.827 12.48,14.827C11.933,14.827 11.48,14.373 11.493,13.813C11.493,13.267 11.946,12.827 12.493,12.827H12.506C13.613,12.84 14.666,13.027 15.653,13.373C18.173,14.267 20.053,16.147 20.946,18.667C21.293,19.653 21.48,20.72 21.493,21.813C21.506,22.373 21.066,22.827 20.506,22.827Z'
    ],
    route: 'smart-house',
    statusKey: 'smartHouseActive',
    audience: 'phys'
  },
  Mobile: {
    key: 'Mobile',
    label: 'Мобильная связь',
    color: '#11DDB1',
    secondaryColor: '#EAFFFD',
    iconViewBox: '0 0 32 32',
    iconPaths: [
      'M26.053,8.72L21.96,4.627C20.707,3.373 19.013,2.667 17.24,2.667H10.667C6.667,2.667 4,5.333 4,9.333V22.667C4,26.667 6.667,29.333 10.667,29.333H21.333C25.333,29.333 28,26.667 28,22.667V13.427C28,11.653 27.293,9.96 26.053,8.72ZM15.333,24.167C15.333,24.443 15.109,24.667 14.833,24.667H13.333C11.133,24.667 9.333,22.867 9.333,20.667V19.833C9.333,19.557 9.557,19.333 9.833,19.333H15C15.187,19.333 15.333,19.48 15.333,19.667V24.167ZM15.333,17.667C15.333,17.853 15.187,18 15,18H9.833C9.557,18 9.333,17.776 9.333,17.5V16.667C9.333,14.467 11.133,12.667 13.333,12.667H14.833C15.109,12.667 15.333,12.89 15.333,13.167V17.667ZM22.667,20.667C22.667,22.867 20.867,24.667 18.667,24.667H17.167C16.89,24.667 16.667,24.443 16.667,24.167V19.667C16.667,19.48 16.813,19.333 17,19.333H22.167C22.443,19.333 22.667,19.557 22.667,19.833V20.667ZM22.667,17.5C22.667,17.776 22.443,18 22.167,18H17C16.813,18 16.667,17.853 16.667,17.667V13.167C16.667,12.89 16.89,12.667 17.167,12.667H18.667C20.867,12.667 22.667,14.467 22.667,16.667V17.5Z'
    ],
    route: 'https://itk-rus.ru/mobilnaya-svyaz.html',
    statusKey: 'mobileActive',
    audience: 'all'
  },
  Other: {
    key: 'Other',
    label: 'Другие опции',
    color: '#A6ADB9',
    secondaryColor: '#F4F6F8',
    iconViewBox: '0 0 24 24',
    iconPaths: ['M12 5a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 011-1z'],
    route: '',
    audience: 'legal'
  }
};

const QUICK_ACTIONS = [
  {
    key: 'topUp',
    action: 'topUp',
    label: 'Пополнить\nбаланс',
    color: '#8C00FF',
    background: 'rgba(140, 0, 255, 0.12)',
    iconViewBox: '0 0 24 24',
    iconPaths: [
      'M11.94,2.21L9.53,7.82H7.12C6.72,7.82 6.33,7.85 5.95,7.93L6.95,5.53L6.99,5.44L7.05,5.28C7.08,5.21 7.1,5.15 7.13,5.1C8.29,2.41 9.59,1.57 11.94,2.21Z',
      'M18.73,8.09L18.71,8.08C18.11,7.91 17.5,7.82 16.88,7.82H10.62L12.87,2.59L12.9,2.52C13.04,2.57 13.19,2.64 13.34,2.69L15.55,3.62C16.78,4.13 17.64,4.66 18.17,5.3C18.26,5.42 18.34,5.53 18.42,5.66C18.51,5.8 18.58,5.94 18.62,6.09C18.66,6.18 18.69,6.26 18.71,6.35C18.86,6.86 18.87,7.44 18.73,8.09Z',
      'M18.29,9.52C17.84,9.39 17.37,9.32 16.88,9.32H7.12C6.44,9.32 5.8,9.45 5.2,9.71C3.46,10.46 2.24,12.19 2.24,14.2V16.15C2.24,16.39 2.26,16.62 2.29,16.86C2.51,20.04 4.21,21.74 7.39,21.95C7.62,21.98 7.85,22 8.1,22H15.9C19.6,22 21.55,20.24 21.74,16.74C21.75,16.55 21.76,16.35 21.76,16.15V14.2C21.76,11.99 20.29,10.13 18.29,9.52ZM14.5,16.19H12.75V18C12.75,18.41 12.41,18.75 12,18.75C11.59,18.75 11.25,18.41 11.25,18V16.19H9.5C9.09,16.19 8.75,15.86 8.75,15.44C8.75,15.03 9.09,14.69 9.5,14.69H11.25V13C11.25,12.59 11.59,12.25 12,12.25C12.41,12.25 12.75,12.59 12.75,13V14.69H14.5C14.91,14.69 15.25,15.03 15.25,15.44C15.25,15.86 14.91,16.19 14.5,16.19Z'
    ]
  },
  {
    key: 'speedTest',
    action: 'speedTest',
    label: 'Измерить\nскорость',
    color: '#11DDB1',
    background: 'rgba(17, 221, 177, 0.12)',
    iconViewBox: '0 0 24 24',
    iconPaths: [
      'M19.14 20.25C18.95 20.25 18.76 20.18 18.61 20.04C18.31 19.75 18.31 19.28 18.6 18.98C20.31 17.24 21.25 14.94 21.25 12.5C21.25 7.4 17.1 3.25 12 3.25C6.9 3.25 2.75 7.4 2.75 12.5C2.75 14.93 3.68 17.22 5.38 18.96C5.67 19.26 5.66 19.73 5.37 20.02C5.07 20.31 4.6 20.3 4.31 20.01C2.34 17.99 1.25 15.32 1.25 12.5C1.25 6.57 6.07 1.75 12 1.75C17.93 1.75 22.75 6.57 22.75 12.5C22.75 15.33 21.66 18.01 19.67 20.03C19.53 20.18 19.33 20.25 19.14 20.25Z',
      'M12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18Z',
      'M18.0184 19.5667C18.4762 20.1423 19.3208 20.243 19.8369 19.719C21.1217 18.4145 22.0658 16.8045 22.5742 15.0309C23.2054 12.8289 23.1333 10.4847 22.3682 8.32559C21.603 6.16645 20.1828 4.30007 18.3059 2.98689C16.4289 1.67372 14.1888 0.979271 11.8982 1.00047C9.60758 1.02167 7.38073 1.75746 5.5284 3.10515C3.67608 4.45284 2.2907 6.34519 1.56561 8.51812C0.840519 10.691 0.81189 13.0361 1.48372 15.2261C2.02482 16.9899 2.99854 18.5823 4.30728 19.8627C4.833 20.3771 5.67563 20.2608 6.12272 19.6768C6.56981 19.0928 6.44927 18.2633 5.94384 17.729C5.0656 16.8006 4.4083 15.6781 4.03001 14.445C3.52085 12.7853 3.54254 11.008 4.09207 9.36118C4.64159 7.71438 5.69153 6.28022 7.09536 5.25884C8.49918 4.23746 10.1869 3.67983 11.9228 3.66377C13.6588 3.6477 15.3565 4.174 16.779 5.16922C18.2015 6.16444 19.2778 7.57892 19.8577 9.21527C20.4376 10.8516 20.4922 12.6282 20.0139 14.2971C19.6585 15.537 19.0221 16.6715 18.1612 17.616C17.6657 18.1595 17.5605 18.9911 18.0184 19.5667Z',
      {
        d: 'M12 14.874L15.7477 9.16627',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '2.5',
        'stroke-linecap': 'round'
      }
    ]
  },
  {
    key: 'chat',
    action: 'chat',
    label: 'Чат с\nподдержкой',
    color: '#0095FF',
    background: 'rgba(0, 149, 255, 0.12)',
    iconViewBox: '0 0 24 24',
    iconPaths: [
      'M13.19,6H6.79C6.53,6 6.28,6.01 6.04,6.04C3.35,6.27 2,7.86 2,10.79V14.79C2,18.79 3.6,19.58 6.79,19.58H7.19C7.41,19.58 7.7,19.73 7.83,19.9L9.03,21.5C9.56,22.21 10.42,22.21 10.95,21.5L12.15,19.9C12.3,19.7 12.54,19.58 12.79,19.58H13.19C16.12,19.58 17.71,18.24 17.94,15.54C17.97,15.3 17.98,15.05 17.98,14.79V10.79C17.98,7.6 16.38,6 13.19,6ZM6.5,14C5.94,14 5.5,13.55 5.5,13C5.5,12.45 5.95,12 6.5,12C7.05,12 7.5,12.45 7.5,13C7.5,13.55 7.05,14 6.5,14ZM9.99,14C9.43,14 8.99,13.55 8.99,13C8.99,12.45 9.44,12 9.99,12C10.54,12 10.99,12.45 10.99,13C10.99,13.55 10.55,14 9.99,14ZM13.49,14C12.93,14 12.49,13.55 12.49,13C12.49,12.45 12.94,12 13.49,12C14.04,12 14.49,12.45 14.49,13C14.49,13.55 14.04,14 13.49,14Z',
      'M21.98,6.79V10.79C21.98,12.79 21.36,14.15 20.12,14.9C19.82,15.08 19.47,14.84 19.47,14.49L19.48,10.79C19.48,6.79 17.19,4.5 13.19,4.5L7.1,4.51C6.75,4.51 6.51,4.16 6.69,3.86C7.44,2.62 8.8,2 10.79,2H17.19C20.38,2 21.98,3.6 21.98,6.79Z'
    ]
  }
];

export default {
  name: 'widget-tariffs-main',
  components: { ItemTariffMain },
  props: {
    isLegal: {
      type: Boolean,
      default: false
    },
    myService: {
      type: Object,
      default: null
    },
    serviceStates: {
      type: Object,
      default: () => ({})
    },
    chatActive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialog: {
        visible: false,
        title: '',
        details: [],
        servid: null,
        state: null,
        type: null
      },
      isBlockLoading: false,
      scrollState: {
        canScrollLeft: false,
        canScrollRight: false
      }
    };
  },
  computed: {
    hasMyService() {
      return Boolean(this.myService);
    },
    serviceTypeLabel() {
      if (!this.myService) {
        return 'Мои услуги';
      }
      if (this.myService.type && typeof this.myService.type === 'string') {
        return this.myService.type;
      }
      const first = this.serviceSummaries[0];
      return first ? first.label : 'Мои услуги';
    },
    serviceTitle() {
      if (!this.myService || !this.myService.title) {
        return 'Информация о тарифе недоступна';
      }
      return this.myService.title;
    },
    serviceSummaries() {
      if (!this.myService || !Array.isArray(this.myService.services)) {
        return [];
      }
      return this.myService.services.map(item => {
        const meta = SERVICE_META[item.type] || null;
        return {
          key: item.type || 'service',
          label: meta ? meta.label : (item.type || 'Услуга'),
          color: meta ? meta.color : '#4D61B7',
          secondaryColor: meta ? meta.secondaryColor : 'rgba(77, 97, 183, 0.1)',
          iconViewBox: meta ? meta.iconViewBox : '0 0 24 24',
          iconPaths: meta ? meta.iconPaths : [],
          details: Array.isArray(item.details) ? item.details : [],
          servid: item.servid || null,
          state: item.state || null,
          type: item.type || null
        };
      });
    },
    serviceCountText() {
      const count = this.serviceSummaries.length;
      if (!count) {
        return 'Нет активных услуг';
      }
      const forms = ['активная услуга', 'активные услуги', 'активных услуг'];
      let form = forms[2];
      if (count % 10 === 1 && count % 100 !== 11) {
        form = forms[0];
      } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
        form = forms[1];
      }
      return `У вас ${count} ${form}`;
    },
    normalizedMyServiceStatus() {
      const rawStatus = this.myService && this.myService.status;
      return typeof rawStatus === 'string' ? rawStatus.trim().toLowerCase() : '';
    },
    statusLabel() {
      const status = this.normalizedMyServiceStatus;
      if (!status) {
        return '';
      }
      if (status === 'active') {
        return 'Активна';
      }
      if (status === 'notactive') {
        return 'Неактивна';
      }
      if (status === 'blocked') {
        return 'Заблокирован';
      }
      return this.myService?.status || '';
    },
    statusClass() {
      const status = this.normalizedMyServiceStatus;
      if (status === 'active') {
        return 'tariffs-widget__status--active';
      }
      if (status === 'notactive') {
        return 'tariffs-widget__status--inactive';
      }
      return 'tariffs-widget__status--inactive';
    },
    hasPaymentInfo() {
      return Boolean(this.myService && this.myService.chargeAmount && this.myService.chargeDate);
    },
    paymentStyle() {
      const isAlert = Boolean(this.myService && this.myService.isBalanceInsufficient);
      return {
        backgroundColor: isAlert ? 'rgba(223, 14, 14, 0.08)' : 'rgba(0, 130, 191, 0.08)',
        color: isAlert ? '#DF0E0E' : '#0082BF'
      };
    },
    serviceCards() {
      const keys = this.isLegal
        ? ['staticIP', 'videoSurveillance', 'Mobile', 'Other']
        : ['Internet', 'Tv', 'Mobile', 'videoSurveillance', 'staticIP', 'Vacation', 'smartHome'];

      return keys
        .map(key => {
          const meta = SERVICE_META[key];
          if (!meta) {
            return null;
          }
          const availabilityKey = meta.statusKey;
          const isActive = availabilityKey ? Boolean(this.serviceStates[availabilityKey]) : true;
          return {
            ...meta,
            isActive
          };
        })
        .filter(Boolean);
    },
    quickActions() {
      return QUICK_ACTIONS.map(action => {
        if (action.key === 'chat') {
          return {
            ...action,
            disabled: !this.chatActive
          };
        }
        return action;
      });
    }
  },
  watch: {
    serviceCards() {
      this.$nextTick(() => {
        this.updateScrollState();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScrollState();
    });
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.updateScrollState);
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateScrollState);
    }
  },
  methods: {
    scrollServices(direction) {
      const list = this.$refs.allServices;
      if (!list) {
        return;
      }
      const distance = list.clientWidth ? list.clientWidth * 0.8 : 240;
      const delta = direction === 'left' ? -distance : distance;
      if (typeof list.scrollBy === 'function') {
        list.scrollBy({ left: delta, behavior: 'smooth' });
      } else {
        list.scrollLeft += delta;
      }
      if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => {
          this.updateScrollState();
        });
      } else {
        this.updateScrollState();
      }
    },
    handleServicesScroll() {
      this.updateScrollState();
    },
    updateScrollState() {
      const list = this.$refs.allServices;
      if (!list) {
        this.scrollState.canScrollLeft = false;
        this.scrollState.canScrollRight = false;
        return;
      }
      const { scrollLeft, scrollWidth, clientWidth } = list;
      const maxScrollLeft = Math.max(scrollWidth - clientWidth, 0);
      const tolerance = 1;
      this.scrollState.canScrollLeft = scrollLeft > tolerance;
      this.scrollState.canScrollRight = scrollLeft < maxScrollLeft - tolerance;
    },
    handleShortcut(action) {
      if (!action || action.disabled) {
        return;
      }
      switch (action.key) {
        case 'topUp':
          if (this.isLegal) {
            this.$router.push({ path: '/documents', query: { page: '1' } });
          } else {
            this.$router.push('/balance');
          }
          break;
        case 'speedTest':
          if (typeof window !== 'undefined') {
            window.open('https://2ip.ru/', '_blank');
          }
          break;
        case 'chat':
          if (!this.chatActive) {
            return;
          }
          this.$router.push('/chat');
          break;
        default:
          if (action.route) {
            this.$router.push(action.route);
          }
      }
    },
    openMyTariffs() {
      this.$router.push('my-tariffs');
    },
    openServiceDetails(service) {
      this.dialog.title = service.label;
      this.dialog.details = service.details && service.details.length ? service.details : [];
      this.dialog.servid = service.servid || null;
      this.dialog.state = service.state || null;
      this.dialog.type = service.type || null;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
      this.dialog.title = '';
      this.dialog.details = [];
      this.dialog.servid = null;
      this.dialog.state = null;
      this.dialog.type = null;
    },
    canToggleBlock() {
      return this.dialog.type === 'Tv' && this.dialog.servid;
    },
    isServiceBlocked() {
      return this.dialog.state === 2;
    },
    toggleBlockService() {
      if (!this.canToggleBlock() || this.isBlockLoading) {
        return;
      }
      if (this.isServiceBlocked()) {
        this.unblockService(this.dialog.servid);
      } else {
        this.blockService(this.dialog.servid);
      }
    },
    blockService(servid) {
      let self = this;
      this.isBlockLoading = true;
      axios.post('v1/services/usbox/block', {
        servid: servid
      }, {
        headers: { Authorization: 'Bearer ' + localStorage.token }
      }).then(function (response) {
        if (response.data.status === 'OK') {
          self.dialog.state = 2;
          self.$emit('update');
        }
        self.isBlockLoading = false;
      }).catch(function () {
        self.isBlockLoading = false;
      });
    },
    unblockService(servid) {
      let self = this;
      this.isBlockLoading = true;
      axios.delete('v1/services/usbox/block', {
        data: { servid: servid },
        headers: { Authorization: 'Bearer ' + localStorage.token }
      }).then(function (response) {
        if (response.data.status === 'OK') {
          self.dialog.state = 3;
          self.$emit('update');
        }
        self.isBlockLoading = false;
      }).catch(function () {
        self.isBlockLoading = false;
      });
    },
    handleServiceSelect(service) {
      if (!service || !service.route) {
        return;
      }
      const { route } = service;
      if (typeof route === 'string' && route.startsWith('http')) {
        if (typeof window !== 'undefined') {
          window.open(route, '_blank');
        }
        return;
      }
      this.$router.push(route);
    }
  }
};
</script>

<style scoped>
.tariffs-widget {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: #ffffff;
  border-radius: 24px;
  border: 1px solid #e9f1f9;
  box-shadow: 0 12px 32px rgba(43, 89, 120, 0.12);
}

.tariffs-widget__card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #e9f1f9;
  border-radius: 24px;
  padding: 18px 20px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  text-align: left;
}

.tariffs-widget__card:hover {
  box-shadow: 0 12px 24px rgba(0, 130, 191, 0.15);
  transform: translateY(-2px);
}

.tariffs-widget__card--empty {
  cursor: default;
}

.tariffs-widget__card--empty:hover {
  box-shadow: none;
  transform: none;
}

.tariffs-widget__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tariffs-widget__service-type {
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 1.1rem;
  color: #0082bf;
}

.tariffs-widget__status {
  font-family: 'Mont', serif;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 6px 12px;
  border-radius: 999px;
  color: #ffffff;
}

.tariffs-widget__status--active {
  background: #19c57b;
}

.tariffs-widget__status--inactive {
  background: #df0e0e;
}

.tariffs-widget__status--blocked {
  background: #df0e0e;
}

.tariffs-widget__title {
  font-family: 'Mont', serif;
  font-size: 1.35rem;
  font-weight: 900;
  color: #24484e;
  align-self: stretch;
  margin-top: -2px;
}

.tariffs-widget__subtitle {
  font-family: 'Mont', serif;
  font-size: 0.95rem;
  color: #6c7b8a;
  text-align: left;
  align-self: stretch;
  margin-top: -4px;
}

.tariffs-widget__services {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
}

.tariffs-widget__service {
  border: none;
  border-radius: 16px;
  padding: 10px 12px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.tariffs-widget__service:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.tariffs-widget__service svg {
  width: 36px;
  height: 36px;
}

.tariffs-widget__service-label {
  font-family: 'Mont', serif;
  font-size: 0.85rem;
  font-weight: 600;
  color: #24484e;
}

.tariffs-widget__payment {
  display: flex;
  align-items: center;
  vertical-align: center;
  gap: 10px;
  border-radius: 16px;
  padding: 8px 16px;
  font-family: 'Mont', serif;
  font-size: 0.9rem;
}

.tariffs-widget__payment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  flex-shrink: 0;
}

.tariffs-widget__payment-icon svg {
  padding-top: 8px;
  width: 28px;
  height: 28px;
}

.tariffs-widget__payment-amount {
  font-weight: 800;
}

.tariffs-widget__all {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
}

.tariffs-widget__all-title {
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: #24484e;
  text-align: left;
}

.tariffs-widget__all-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.tariffs-widget__scroll-controls {
  display: inline-flex;
  gap: 8px;
}

.tariffs-widget__scroll-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #d1e3f2;
  background: #ffffff;
  color: #0082bf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.tariffs-widget__scroll-button:hover {
  background-color: #f0f7fc;
  border-color: #bcd5eb;
  box-shadow: 0 4px 12px rgba(0, 130, 191, 0.18);
}

.tariffs-widget__scroll-button:focus-visible {
  outline: 2px solid #0082bf;
  outline-offset: 2px;
}

.tariffs-widget__scroll-button svg {
  width: 20px;
  height: 20px;
}

.tariffs-widget__scroll-button--disabled,
.tariffs-widget__scroll-button--disabled:hover {
  cursor: default;
  background-color: #f5f8fb;
  border-color: #e1ebf5;
  color: #9fb2c4;
  box-shadow: none;
}

.tariffs-widget__all-scroll {
  position: relative;
}

.tariffs-widget__all-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #c3d6e9 transparent;
}

.tariffs-widget__all-list::-webkit-scrollbar {
  height: 6px;
}

.tariffs-widget__all-list::-webkit-scrollbar-track {
  background: transparent;
}

.tariffs-widget__all-list::-webkit-scrollbar-thumb {
  background: #c3d6e9;
  border-radius: 999px;
}

.tariffs-widget__shortcuts {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 24px;
  border: 1px solid #e9f1f9;
  background: #ffffff;
}

.tariffs-widget__shortcut {
  flex: 1 1 0;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 12px 8px;
  border-radius: 20px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.tariffs-widget__shortcut:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  background-color: rgba(0, 130, 191, 0.05);
}

.tariffs-widget__shortcut--disabled,
.tariffs-widget__shortcut--disabled:hover {
  opacity: 0.45;
  cursor: default;
  transform: none;
  box-shadow: none;
  background-color: transparent;
}

.tariffs-widget__shortcut:focus-visible {
  outline: 2px solid #0082bf;
  outline-offset: 2px;
}

.tariffs-widget__shortcut-icon {
  width: 44px;
  height: 44px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tariffs-widget__shortcut-icon svg {
  width: 32px;
  height: 32px;
}

.tariffs-widget__shortcut-label {
  font-family: 'Mont', serif;
  font-weight: 700;
  font-size: 0.9rem;
  color: #24484e;
  text-align: center;
  line-height: 1.25;
}

.tariffs-widget__dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.tariffs-widget__dialog {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px;
  width: min(420px, calc(100% - 32px));
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.18);
  max-height: 80vh;
  overflow-y: auto;
  text-align: left;
}

.tariffs-widget__dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.tariffs-widget__dialog-title {
  font-family: 'Mont', serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #24484e;
}

.tariffs-widget__dialog-close {
  border: none;
  background: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  color: #6c7b8a;
}

.tariffs-widget__dialog-list {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Mont', serif;
  font-size: 0.95rem;
  color: #0082bf;
  text-align: left;
}

.tariffs-widget__dialog-list li {
  color: inherit;
}

.tariffs-widget__dialog-empty {
  font-family: 'Mont', serif;
  font-size: 0.95rem;
  color: #6c7b8a;
}

.tariffs-widget__dialog-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.tariffs-widget__dialog-button {
  padding: 10px 24px;
  border: none;
  border-radius: 12px;
  font-family: 'Mont', serif;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  color: #ffffff;
  transition: opacity 0.2s ease;
}

.tariffs-widget__dialog-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tariffs-widget__dialog-button--block {
  background: #DF0E0E;
}

.tariffs-widget__dialog-button--unblock {
  background: #34C234;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
